function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { forwardRef, useEffect } from 'react';
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import setting from "./setting";
import { getPrefixCls } from "../../utils/common";
import "./style.less";
import { Tabs as AntTabs } from 'antd-mobile';
import commonPool from "../../store/commonPool";
var Tabs = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$params, _props$schema, _props$schema$params;
  var prefixCls = getPrefixCls('SmTabs');
  var _props$tabsList = props.tabsList,
    tabsList = _props$tabsList === void 0 ? [{
      tabName: 'tab1'
    }, {
      tabName: 'tab2'
    }] : _props$tabsList,
    title = props.title;
  var _React$useState = React.useState('0'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeKey = _React$useState2[0],
    setActiveKey = _React$useState2[1];
  var refs = commonPool.getRefs();
  var source = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.source) || ((_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.source);
  var isDev = source === 'development';
  var initActivityTab = function initActivityTab() {
    if (isDev) return;
    tabsList === null || tabsList === void 0 ? void 0 : tabsList.forEach(function (item, index) {
      if (item.target) {
        if (!refs) return;
        if (Number(activeKey) === index) {
          // 选中的tab
          for (var key in refs) {
            if (Object.prototype.hasOwnProperty.call(refs, key)) {
              var _refs$key;
              if (((_refs$key = refs[key]) === null || _refs$key === void 0 ? void 0 : _refs$key.title) === item.target) {
                var _refs$key2, _refs$key2$ref, _refs$key2$ref$curren, _refs$key2$ref$curren2, _refs$key2$ref$curren3;
                refs === null || refs === void 0 ? void 0 : (_refs$key2 = refs[key]) === null || _refs$key2 === void 0 ? void 0 : (_refs$key2$ref = _refs$key2.ref) === null || _refs$key2$ref === void 0 ? void 0 : (_refs$key2$ref$curren = _refs$key2$ref.current) === null || _refs$key2$ref$curren === void 0 ? void 0 : (_refs$key2$ref$curren2 = (_refs$key2$ref$curren3 = _refs$key2$ref$curren).toggleVisible) === null || _refs$key2$ref$curren2 === void 0 ? void 0 : _refs$key2$ref$curren2.call(_refs$key2$ref$curren3, true);
              }
            }
          }
        } else {
          // 未选中的tab
          for (var _key in refs) {
            if (Object.prototype.hasOwnProperty.call(refs, _key)) {
              var _refs$_key;
              if (((_refs$_key = refs[_key]) === null || _refs$_key === void 0 ? void 0 : _refs$_key.title) === item.target) {
                var _refs$_key2, _refs$_key2$ref, _refs$_key2$ref$curre, _refs$_key2$ref$curre2, _refs$_key2$ref$curre3;
                refs === null || refs === void 0 ? void 0 : (_refs$_key2 = refs[_key]) === null || _refs$_key2 === void 0 ? void 0 : (_refs$_key2$ref = _refs$_key2.ref) === null || _refs$_key2$ref === void 0 ? void 0 : (_refs$_key2$ref$curre = _refs$_key2$ref.current) === null || _refs$_key2$ref$curre === void 0 ? void 0 : (_refs$_key2$ref$curre2 = (_refs$_key2$ref$curre3 = _refs$_key2$ref$curre).toggleVisible) === null || _refs$_key2$ref$curre2 === void 0 ? void 0 : _refs$_key2$ref$curre2.call(_refs$_key2$ref$curre3, false);
              }
            }
          }
        }
      }
      // 图片轮播锚点
      if (item.swiperTarget && (item.swiperTitleTarget || item.swiperTitleTarget === 0)) {
        if (Number(activeKey) === index) {
          // 选中的tab
          for (var _key2 in refs) {
            if (Object.prototype.hasOwnProperty.call(refs, _key2)) {
              var _refs$_key3;
              if (((_refs$_key3 = refs[_key2]) === null || _refs$_key3 === void 0 ? void 0 : _refs$_key3.title) === item.swiperTarget) {
                var _refs$_key4, _refs$_key4$ref, _refs$_key4$ref$curre, _refs$_key4$ref$curre2, _refs$_key4$ref$curre3;
                refs === null || refs === void 0 ? void 0 : (_refs$_key4 = refs[_key2]) === null || _refs$_key4 === void 0 ? void 0 : (_refs$_key4$ref = _refs$_key4.ref) === null || _refs$_key4$ref === void 0 ? void 0 : (_refs$_key4$ref$curre = _refs$_key4$ref.current) === null || _refs$_key4$ref$curre === void 0 ? void 0 : (_refs$_key4$ref$curre2 = (_refs$_key4$ref$curre3 = _refs$_key4$ref$curre).swipeTo) === null || _refs$_key4$ref$curre2 === void 0 ? void 0 : _refs$_key4$ref$curre2.call(_refs$_key4$ref$curre3, item.swiperTitleTarget);
              }
            }
          }
        }
      }
    });
  };
  useEffect(function () {
    initActivityTab();
    // 避免初始化时，其余组件未加载，导致隐藏失效，300ms重新执行状态
    setTimeout(function () {
      initActivityTab();
    }, 300);
  }, [tabsList, activeKey, refs]);
  return /*#__PURE__*/React.createElement("div", {
    id: title ? "me-".concat(title) : undefined
  }, /*#__PURE__*/React.createElement(AntTabs, {
    style: {
      '--title-font-size': '12px'
    },
    activeKey: activeKey,
    onChange: function onChange(e) {
      return setActiveKey(e === null || e === void 0 ? void 0 : e.toString());
    },
    activeLineMode: "auto"
  }, tabsList === null || tabsList === void 0 ? void 0 : tabsList.map(function (item, index) {
    return /*#__PURE__*/React.createElement(AntTabs.Tab, {
      key: index === null || index === void 0 ? void 0 : index.toString(),
      title: item.tabName
    });
  })));
});
var EnhancedTabs = EnhanceComponent(Tabs);
EnhancedTabs.settings = setting;
export default EnhancedTabs;